module.exports = __webpack_public_path__ + "img/nopreview.2bcbfe9.png";